// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"312":"2e29c778","453":"03346f77","551":"b0ffe9f2","640":"19e331de","965":"64ba965f"}[chunkId] + ".chunk.js";
};